import React from 'react';
import { resourcesFiles } from '../../../helpers/backend_helper';

const fm = new Intl.NumberFormat("es-MX", {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

const Columns = ( addUpd, destroy,setModalFile,modalFile) => {
	const getFiles = async(id) =>{
		let params={params:{relation:'sale',id:id,field:'sale_id'}}
		const response = await resourcesFiles('get',params);
		setModalFile({...modalFile,show:true,id:id,items:response.files});
	}

	let columns = [
		{
			id: 'fecha',
			name: 'Fecha',
			selector: row => row.date+' '+row.time,
			sortable: true,
			width:'15%'
		},
		{
			id: 'unit_id',
			name: 'Unidad',
			selector: row => `${row.unit?.number ?? ''}`,
			sortable: true,
		},
		{
			id: 'amount',
			name: 'Cantidad',
			selector: row => fm.format(row.amount),
			sortable: true,
			wrap: true,

		},
		{
			id: 'unit_price',
			name: 'Precio Unitario',
			selector: row => fm.format(row.unit_price),
			sortable: true,
		},
		{
			id: 'total',
			name: 'Total',
			selector: row => { return fm.format(Number(row.amount) * Number(row.unit_price)); },
			sortable: true,

		},
		{
			id: 'files',
			name: 'Documentación',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						<button className="btn btn-primary btn-sm" title='Listado de Documentos' onClick={() => getFiles(row.id)}>
							<i className="fa fa-folder-open"></i>
						</button>
					</div>
				</div>
				),
		},
		{
			id: 'actions',
			name: 'Acciones',
			button: true,
			cell: row => (
				<div className="d-flex justify-content-between">
					<div className="p-2">
						<button className="btn btn-primary btn-sm" title='Editar venta' onClick={() => addUpd(row)}><i className="fas fa-edit"></i></button>
					</div>
					<div className="p-2">
						<button className="btn btn-danger btn-sm" title='Eliminar venta' onClick={() => destroy(row.id)}><i className="fas fa-trash"></i></button>
					</div>
				</div>
				),
		}
		];
	return columns;
}

export default Columns;